import React from "react";
import { Route, Switch } from "react-router-dom";
import IntegrationIdBreadcrumbs from "./IntegrationIdBreadcrumbs";
import InstanceIdBreadcrumbs from "./InstanceIdBreadcrumbs";

export interface Instance {
  id?: string;
  [key: string]: unknown;
}

export interface Integration {
  id?: string;
  name?: string;
  instances?: Instance[];
}

interface BreadcrumbsProps {
  basePath: string;
  baseText: React.ReactNode;
  integrations?: Integration[];
  instanceDisplayProperty: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  basePath,
  baseText,
  integrations,
  instanceDisplayProperty,
}) => (
  <Switch>
    <Route exact path={`${basePath}`}>
      {baseText}
    </Route>
    <Route exact path={`${basePath}/:integrationId`}>
      <IntegrationIdBreadcrumbs
        basePath={basePath}
        baseText={baseText}
        integrations={integrations}
      />
    </Route>
    <Route path={`${basePath}/:integrationId/:instanceId`}>
      <InstanceIdBreadcrumbs
        basePath={basePath}
        baseText={baseText}
        integrations={integrations}
        instanceDisplayProperty={instanceDisplayProperty}
      />
    </Route>
  </Switch>
);

export default Breadcrumbs;
